import debounce from 'lodash/debounce'

import { DEFAULT_DEBOUNCE_TIMEOUT } from '@/context/constants'

const useDebounce = (func: any, timeout: number = DEFAULT_DEBOUNCE_TIMEOUT) => {
  const debouncedFunc = debounce(func, timeout)

  return debouncedFunc
}

export default useDebounce
